import { Typography, ButtonBase } from "@mui/material"
import { Button, SvgIcon, type FC } from ".."
import { alpha } from "@mui/material/styles"

interface TripCTAProps {
  buttonText?: string
  onClick?: () => void
}

const TripCTA: FC<TripCTAProps> = ({ buttonText = "Request a Custom Quote", onClick }) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={(theme) => ({
         ...theme.typography["link.lg"],
        "fontWeight": 400,
        "color": theme.palette["neutral.900"].main,
        "bgcolor": alpha(theme.palette["primary.800"].main, 0.05),
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "center",
        "border": `1px solid ${theme.palette["primary.800"].main}`,
        "height": "50px",
        "width": "100%",
        padding: {
          xs: "10px 15px!important",  
          xl: "12px 20px!important", 
        },
        "borderRadius": 1,
        "transition": theme.transitions.create(["background-color", "border-color", "color"]),
        "&:hover": {
          bgcolor: theme.palette["primary.800"].main,
          color: theme.palette["neutral.100"].main,
        },
      })}
    >
      <Typography
        variant="body.md"
        fontWeight={400}
        sx={(theme) => ({
          color: theme.palette["neutral.100"].main,
          fontSize: {
            xs: "14px",
            xl: "18px", 
          },
        })}
      >
        {buttonText}
      </Typography>
    </ButtonBase>
  )
}

export default TripCTA
